const footerStyle = {
    width:'100%',
    height:'120px',
    textAlign:'center',
    lineHeight:'120px'
}

function Footer(){
    return <div style={ footerStyle }>
        © Copyright 2015 - 2025 by Joy Fashion limited 
    </div>
}

export default Footer;